<template>
    <div class="p-3">
        <h2 class="text-uppercase mb-0">
            {{ $t('transport_log.title') }}
        </h2>
    </div>
    <SearchWithDate
        url="/merchant/transportlog"
        :query="query"
        :dates="dates"
        :date="date"
    />

    <table class="table table-striped">
        <thead>
        <tr>
            <th>{{ $t('transport_log.field.fullname') }}</th>
            <th>{{ $t('transport_log.field.queueType') }}</th>
            <th>{{ $t('transport_log.field.state') }}</th>
            <th>{{ $t('transport_log.field.created_at') }}</th>
            <th>{{ $t('transport_log.field.duration') }}</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in getList" style="vertical-align: middle">
            <td>{{ item.firstname }} {{ item.lastname }}</td>
            <td>{{ item.queueType }}</td>
            <td>
                <span class="badge" :class="getBadgeClass(item.payload.state)">
                    {{ $t('transport.states.' + item.payload.state) }}
                </span>
            </td>
            <td>{{ item.created_at }}</td>
            <td>{{ item.payload.waiting_time }}</td>
            <td class="text-end">
                <button type="button" @click="onOpenModal(item)" class="btn btn-primary">
                    {{ $t('transport_log.buttons.preview') }}
                </button>
            </td>
        </tr>
        </tbody>
    </table>

    <Pagination v-if="list.current_page !== list.last_page" :links="list.links"/>

    <div class="modal fade" tabindex="-1" id="previewModal" data-bs-backdrop="static" >
        <div class="modal-dialog modal-fullscreen-md-down">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" v-if="selectedElement" id="staticBackdropLabel">
                        {{ selectedElement.firstname }} {{ selectedElement.lastname }}
                    </h1>
                    <button type="button" class="btn-close" @click="onCloseModal()"></button>
                </div>

                <div class="modal-body" v-if="selectedElement">
                    <PreviewField
                        v-for="(item, index) in selectedElement.payload"
                        :title="index"
                        :value="item"
                        :key="index"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MerchantLayout from "../../../Layouts/MerchantLayout.vue";
import PreviewField from "../../../components/PreviewField.vue";
import * as Bootstrap from "bootstrap"
import { router } from "@inertiajs/vue3";
import Pagination from "../../../components/Pagination.vue";
import SearchWithDate from "../../../components/SearchWithDate.vue";

export default {
    name: "List",
    layout: MerchantLayout,
    props: {
        list: {
            type: Object,
            required: true,
        },
        queueType: {
            type: String
        },
        query: {
            type: String
        },
        page: {
            type: Number,
            default: 1
        },
        dates: {
            type: Array,
            default: []
        },
        date: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            selectedElement: null,
            previewModal: null
        }
    },
    methods: {
        onOpenModal(item) {
            this.selectedElement = item;
            this.previewModal.show();
        },
        onCloseModal() {
            this.previewModal.hide();
            this.selectedElement = null;
        },
        onSearch(){
            router.get("/merchant/transportlog", {query: this.query}, {
                only: ['list']
            });
        }
    },
    computed: {
        getList() {
            return this.list.data
        },
        getBadgeClass() {
            const states = {
                'finished': 'text-bg-success',
                'cancelled': 'text-bg-danger',
                'waiting': 'text-bg-warning'
            };
            return (state) => {
                return states[state];
            }
        }
    },
    mounted() {
        this.previewModal = new Bootstrap.Modal('#previewModal');
    },
    components:{
        SearchWithDate,
        Pagination,
        PreviewField,
    }
}
</script>

<style scoped>

</style>
